import { render, staticRenderFns } from "./login_form.vue?vue&type=template&id=0139c723&scoped=true&"
import script from "./login_form.vue?vue&type=script&lang=js&"
export * from "./login_form.vue?vue&type=script&lang=js&"
import style0 from "./login_form.vue?vue&type=style&index=0&id=0139c723&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139c723",
  null
  
)

export default component.exports